import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkConfidentialityLevelRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const dataProtection = control.get('dataProtection')!.value;
	const confidentialityLevel = control.get('confidentialityLevel')!.value;

	return dataProtection ===  "1" && !isNaN(confidentialityLevel) && Number(confidentialityLevel) <= 1  ? { checkConfidentialityLevelFlag: true } : null;
};
